import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../lib/supabase';

export function useCountryCheck() {
  const { user, isAuthenticated } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't redirect if not authenticated or already on country setup page
    if (!isAuthenticated || !user || location.pathname === '/country-setup') {
      return;
    }

    // Check if user has country information in metadata
    const userMetadata = user.user_metadata || {};
    const hasCountry = userMetadata.country_code || userMetadata.country;

    // If no country info, redirect to country setup
    if (!hasCountry) {
      console.log('User missing country information, redirecting to setup');
      navigate('/country-setup', { replace: true });
    }
  }, [isAuthenticated, user, navigate, location.pathname]);

  return {
    hasCountry: user?.user_metadata?.country_code || user?.user_metadata?.country,
    needsCountrySetup: isAuthenticated && user && !user.user_metadata?.country_code
  };
} 